import styled from 'styled-components';

import { Color } from '../../../../../../constants/Colors';
import { MediaQuery, Shadow } from '../../../../../../constants/Styles';
import { Typography } from '../../../../../../constants/Typographies';

export const AlgoliaSearchHeader = styled.div`
  margin-left: 15px;
  margin-right: 15px;
  flex-grow: 2;
  position: relative;

  svg:first-of-type {
    position: absolute;
    top: 15px;
    left: 22px;
  }

  button {
    display: none;
  }

  ${MediaQuery.L_AND_DOWN} {
    margin-right: 15px;
    padding-bottom: 0px;
    margin-left: 10px;
  }
`;

export const AlgoliaSearchMain = styled.div`
  position: absolute;
  margin: 0 0 0 20px;
  z-index: 100;
  background: ${Color.WHITE};
  box-shadow: ${Shadow.BLUE_ACTIVE};
  border-radius: 15px;
  max-width: 520px;
  max-height: 400px;
  overflow: hidden;
  overflow-y: scroll;

  ::-webkit-scrollbar {
    width: 15px; /* width of the entire scrollbar */
  }

  ::-webkit-scrollbar-track {
    background: transparent; /* color of the tracking area */
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${Color.MYSTIC}; /* color of the scroll thumb */
    border-radius: 20px; /* roundness of the scroll thumb */
    border: 3px solid ${Color.WHITE}; /* creates padding around scroll thumb */
  }

  ${MediaQuery.L_AND_DOWN} {
    max-width: 360px;
    margin: 55px 0 0 55px;
  }

  ${MediaQuery.S_AND_DOWN} {
    width: 85%;
    margin: 55px 10px;
  }
`;

export const CustomHistsContainer = styled.div``;

export const HitsItem = styled.li`
  list-style: none;
  padding: 15px;
  margin: 15px;
  border-radius: 15px;
  &:hover {
    background: ${Color.WHISPER};
  }
`;

export const HitContainer = styled.a``;

export const PageTitle = styled.div``;

export const Title = styled.p`
  ${Typography.L_BOLDER};
  color: ${Color.CLOUD_BURST};
  padding-bottom: 5px;
`;

export const PageDescription = styled.div``;

export const Description = styled.p`
  ${Typography.M};
  color: ${Color.DOLPHIN};
`;
